// extracted by mini-css-extract-plugin
export default {"container":"ProductPage_container__KhqzZ"};